/* Cross-sells (Search & Discovery) — ALWAYS add to cart
   - Single variant: add that variant
   - Multi-variant: add the first AVAILABLE variant
   - Drawer stays open (morph inner HTML) and refreshes after add/remove/qty
   - Excludes products already in cart (by product_id + variant_id)
   - Uses Liquid <template id="cross-sells-item-template"> as card shell

   + Custom collection metafield discount support:
   - initial fallback price comes from recommendations JSON
   - then card price is hydrated from the real product page HTML for the picked variant
   - so it reuses your server-side price logic from PDP
*/
(function () {
  var ROOT = '[data-cross-sells]';
  var INIT = 'data-cross-sells-initialized';
  var priceMarkupCache = Object.create(null);

  /* ------------ utils ------------ */
  function debounce(fn, wait){ var t; return function(){ clearTimeout(t); var a=arguments, c=this; t=setTimeout(function(){ fn.apply(c,a); }, wait); }; }
  function sleep(ms){ return new Promise(function(r){ setTimeout(r, ms); }); }

  function money(cents, currency){
    var n=(parseInt(cents,10)||0)/100;
    try{
      return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency}).format(n);
    }catch(e){
      return n.toFixed(2);
    }
  }

  function normalizeText(str){
    return String(str || '')
      .replace(/\u00A0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getDrawerEl(){ return document.querySelector('.quick-cart[data-section-id]'); }

  function emitLifecycle(target){
    try{ target.dispatchEvent(new CustomEvent('content:updated',{bubbles:true})); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('content:updated',{bubbles:true})); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true})); }catch(e){}
    try{ document.dispatchEvent(new CustomEvent('theme:section:load',{bubbles:true})); }catch(e){}
  }

  /* ------------ API ------------ */
  function fetchRecs(pid,intent,limit){
    var url='/recommendations/products.json?product_id='+pid+'&limit='+encodeURIComponent(limit)+'&intent='+encodeURIComponent(intent);
    return fetch(url,{credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : {products:[]}; })
      .catch(function(){ return {products:[]}; });
  }

  function getCartState(){
    return fetch('/cart.js',{credentials:'same-origin'})
      .then(function(r){ return r.ok ? r.json() : {items:[]}; })
      .catch(function(){ return {items:[]}; });
  }

  function postAddToCart(variantId,qty){
    var fd=new FormData();
    fd.append('id',variantId);
    fd.append('quantity',qty||1);

    return fetch('/cart/add.js',{
      method:'POST',
      credentials:'same-origin',
      body:fd
    }).then(function(r){
      return r.ok ? r.json() : Promise.reject(r);
    });
  }

  /* ------------ Drawer refresh (morph inner) ------------ */
  var drawerFetchController = null;
  var drawerRefreshing = false;

  function morph(dst, src){
    if (!dst || !src) return;
    dst.innerHTML = src.innerHTML;
  }

  function refreshQuickCart(){
    var holder=getDrawerEl();
    if(!holder) return Promise.resolve();

    var sectionId=holder.getAttribute('data-section-id');
    if(!sectionId) return Promise.resolve();

    if (drawerFetchController) drawerFetchController.abort();
    drawerFetchController = new AbortController();

    if (drawerRefreshing) return Promise.resolve();
    drawerRefreshing = true;

    return fetch('/?sections='+encodeURIComponent(sectionId),{
      credentials:'same-origin',
      signal: drawerFetchController.signal
    })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(json){
        if(!json || !json[sectionId]) return;

        var tmp=document.createElement('div');
        tmp.innerHTML=json[sectionId];

        var freshRoot = tmp.querySelector('.quick-cart') || tmp.firstElementChild;

        morph(holder.querySelector('.quick-cart__heading'), freshRoot && freshRoot.querySelector('.quick-cart__heading'));
        morph(holder.querySelector('.quick-cart__items'),   freshRoot && freshRoot.querySelector('.quick-cart__items'));
        morph(holder.querySelector('.quick-cart__footer'),  freshRoot && freshRoot.querySelector('.quick-cart__footer'));

        emitLifecycle(holder);
      })
      .catch(function(){})
      .finally(function(){
        drawerRefreshing=false;
        drawerFetchController=null;
      });
  }

  function waitForDrawerItemsMutation(timeout){
    return new Promise(function(resolve){
      var holder=getDrawerEl();
      if(!holder){ resolve(); return; }

      var list=holder.querySelector('.quick-cart__items');
      if(!list){ resolve(); return; }

      var done=false;
      var to=setTimeout(function(){
        if(!done){
          done=true;
          obs.disconnect();
          resolve();
        }
      }, timeout||700);

      var obs=new MutationObserver(function(m){
        if(done) return;
        if(m.some(function(x){ return x.type==='childList'; })){
          done=true;
          clearTimeout(to);
          obs.disconnect();
          resolve();
        }
      });

      obs.observe(list,{childList:true,subtree:true});
    });
  }

  function waitForCartSettle(prevKeys, timeout){
    var started=Date.now();

    function loop(){
      return getCartState().then(function(c){
        var keys=(c.items||[]).map(function(i){
          return i.key || (i.product_id+':'+i.variant_id);
        }).join(',');

        if(keys!==prevKeys) return true;
        if(Date.now()-started > (timeout||1200)) return true;

        return sleep(120).then(loop);
      });
    }

    return loop();
  }

  /* ------------ Liquid template cloning ------------ */
  function getCardTemplate(){
    var tpl = document.getElementById('cross-sells-item-template');
    return (tpl && 'content' in tpl) ? tpl.content.firstElementChild : null;
  }

  function buildPriceHTML(price, compareAt, currency){
    price=parseInt(price||0,10);
    compareAt=parseInt(compareAt||0,10);

    if(compareAt>price){
      return ''
        + '<span class="visually-hidden">Regular price</span>'
        + '<s class="t-subdued">'+ money(compareAt,currency) +'</s>'
        + '<div class="sale" data-price>'+ money(price,currency) +'</div>';
    }else{
      return '<span class="cross-sells__item-price">'+ money(price,currency) +'</span>';
    }
  }

  function buildPriceHTMLFromMarkup(markup){
    if(!markup || !markup.price_text) return '';

    if(markup.compare_text){
      return ''
        + '<span class="visually-hidden">Regular price</span>'
        + '<s class="t-subdued">'+ markup.compare_html +'</s>'
        + '<div class="sale" data-price>'+ markup.price_html +'</div>';
    }

    return '<span class="cross-sells__item-price">'+ markup.price_html +'</span>';
  }

  function firstAvailableVariant(variants){
    if(!Array.isArray(variants) || !variants.length) return null;

    for(var i=0;i<variants.length;i++){
      if(variants[i] && variants[i].available && variants[i].id) return variants[i];
    }

    return variants[0] || null;
  }

  function fetchProductPriceMarkup(handle, variantId, currency){
    if(!handle || !variantId) return Promise.resolve(null);

    var key = [
      document.documentElement.lang || '',
      currency || '',
      handle,
      variantId
    ].join('|');

    if(priceMarkupCache[key]) return priceMarkupCache[key];

    var url = '/products/' + encodeURIComponent(handle) + '?variant=' + encodeURIComponent(variantId);

    priceMarkupCache[key] = fetch(url, { credentials:'same-origin' })
      .then(function(r){
        return r.ok ? r.text() : '';
      })
      .then(function(html){
        if(!html) return null;

        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var priceRoot =
          tmp.querySelector('.product__price')
          || tmp.querySelector('.product__price-and-ratings .ff-product-price')
          || tmp.querySelector('[data-price]');

        if(!priceRoot) return null;

        var priceEl = null;
        var compareEl = null;

        if(priceRoot.matches && priceRoot.matches('[data-price]')){
          priceEl = priceRoot;
          compareEl = tmp.querySelector('[data-compare-price]');
        } else {
          priceEl = priceRoot.querySelector('[data-price]') || tmp.querySelector('[data-price]');
          compareEl = priceRoot.querySelector('[data-compare-price]') || tmp.querySelector('[data-compare-price]');
        }

        var priceText = priceEl ? normalizeText(priceEl.textContent) : '';
        var compareText = compareEl ? normalizeText(compareEl.textContent) : '';

        if(!priceText) return null;

        return {
          price_html: priceEl.innerHTML,
          compare_html: compareEl ? compareEl.innerHTML : '',
          price_text: priceText,
          compare_text: compareText
        };
      })
      .catch(function(){
        return null;
      });

    return priceMarkupCache[key];
  }

  function hydrateCardPrice(node, product, variant, currency){
    if(!node || !product || !variant || !variant.id || !product.handle) return;

    var priceWrap = node.querySelector('[data-cs-price-wrapper]');
    if(!priceWrap) return;

    fetchProductPriceMarkup(product.handle, variant.id, currency).then(function(markup){
      if(!markup || !markup.price_text) return;

      var html = buildPriceHTMLFromMarkup(markup);
      if(!html) return;

      priceWrap.innerHTML = html;
    });
  }

  function cloneCardAndFill(p, currency){
    var tpl = getCardTemplate();
    if(!tpl) return null;

    var node = tpl.cloneNode(true);

    var link  = node.querySelector('[data-cs-link]');
    if(link) link.href = '/products/' + p.handle;

    var tlink = node.querySelector('[data-cs-title-link]');
    if(tlink) tlink.href = '/products/' + p.handle;

    var title = node.querySelector('[data-cs-title]');
    if(title) title.textContent = p.title || '';

    var img = node.querySelector('[data-cs-img]');
    var imgUrl = (p.featured_image && p.featured_image.url) || p.featured_image || (p.images && p.images[0]) || '';

    if(img && imgUrl){
      img.src = imgUrl;
      img.alt = p.title || '';
    }else if(img){
      img.remove();
    }

    var vPick = firstAvailableVariant(p.variants) || {};
    var priceWrap = node.querySelector('[data-cs-price-wrapper]');

    if(priceWrap){
      var price = (vPick.price != null ? vPick.price : p.price);
      var compare = (vPick.compare_at_price != null ? vPick.compare_at_price : p.compare_at_price);

      priceWrap.innerHTML = buildPriceHTML(price, compare, currency);
    }

    var btn = node.querySelector('[data-cs-button]');
    if(btn){
      btn.setAttribute('data-title', (p.title||'').replace(/"/g,'&quot;'));
      btn.setAttribute('data-product-url','/products/' + p.handle);
      btn.setAttribute('data-product-handle', p.handle);

      if(vPick && vPick.id){
        btn.setAttribute('data-add-item-id', String(vPick.id));
      }else{
        btn.setAttribute('disabled','disabled');
      }

      btn.removeAttribute('data-quick-add-trigger');
    }

    if(vPick && vPick.id){
      hydrateCardPrice(node, p, vPick, currency);
    }

    return node;
  }

  /* ------------ Render ------------ */
  function renderInto(root, products){
    var isSlider = root.getAttribute('data-is-slider') === 'true';
    var wrapper  = root.querySelector('.cross-sells__items');
    if(!wrapper) return;

    var anchor = wrapper.querySelector('[data-cross-sells-anchor]');
    var list   = wrapper.querySelector('[data-cross-sells-list]');
    var target = isSlider ? anchor : list;
    if(!target) return;

    var max      = parseInt(root.getAttribute('data-max') || '3', 10);
    var currency = root.getAttribute('data-currency') || 'USD';

    if (isSlider) {
      var track = wrapper.querySelector('.scroll-slider__track');
      if (track) {
        var ph=document.createElement('div');
        ph.setAttribute('data-cross-sells-anchor','');
        track.innerHTML='';
        track.appendChild(ph);
        target=ph;
      }
    } else if (list) {
      list.innerHTML='';
    }

    var frag = document.createDocumentFragment();

    for(var i=0;i<products.length && i<max;i++){
      var node = cloneCardAndFill(products[i], currency);
      if(node) frag.appendChild(node);
    }

    if (isSlider) {
      target.replaceWith(frag);
    } else {
      target.appendChild(frag);
    }

    emitLifecycle(wrapper);
  }

  function renderCrossSells(root, opts){
    var seedIds   = opts.seedIds || [];
    var usedPids  = new Set((opts.cartProductIds || []).map(function(n){ return parseInt(n,10); }));
    var usedVids  = new Set((opts.cartVariantIds || []).map(function(n){ return parseInt(n,10); }));

    root.style.removeProperty('display');
    root.classList.remove('is-empty');

    var intent = root.getAttribute('data-intent') || 'complementary';
    var max    = parseInt(root.getAttribute('data-max') || '3', 10);

    var appended=0, collected=[];

    function pushFiltered(prods){
      for(var i=0;i<prods.length && appended<max;i++){
        var p=prods[i];
        if(!p || p.available===false) continue;
        if(usedPids.has(parseInt(p.id,10))) continue;

        if(Array.isArray(p.variants)){
          var overlap = p.variants.some(function(v){
            return usedVids.has(parseInt(v.id,10));
          });
          if (overlap) continue;
        }

        collected.push(p);
        usedPids.add(parseInt(p.id,10));
        appended++;
      }
    }

    (function step(i, retry){
      if(appended>=max || i>=seedIds.length){
        if(appended===0 && !retry){
          getCartState().then(function(c2){
            var pids=(c2.items||[]).map(function(it){ return it.product_id; });
            var vids=(c2.items||[]).map(function(it){ return it.variant_id; });

            renderCrossSells(root, {
              seedIds: pids.slice(),
              cartProductIds: pids,
              cartVariantIds: vids
            });
          });
        } else if (appended===0) {
          root.classList.add('is-empty');
          root.style.display='none';
        } else {
          renderInto(root, collected);
        }
        return;
      }

      fetchRecs(seedIds[i], intent, max).then(function(d){
        pushFiltered((d && d.products) ? d.products : []);
        step(i+1, retry);
      });
    })(0, false);
  }

  function refreshAllCrossSells(){
    return getCartState().then(function(c){
      var pids=(c.items||[]).map(function(i){ return i.product_id; });
      var vids=(c.items||[]).map(function(i){ return i.variant_id; });

      document.querySelectorAll(ROOT).forEach(function(root){
        renderCrossSells(root, {
          seedIds: pids.slice(),
          cartProductIds: pids,
          cartVariantIds: vids
        });
      });
    });
  }

  /* ------------ Init ------------ */
  function init(root){
    if(!root || root.getAttribute(INIT)==='true') return;
    root.setAttribute(INIT,'true');
    refreshAllCrossSells();
  }

  document.querySelectorAll(ROOT).forEach(init);

  var mo=new MutationObserver(function(muts){
    muts.forEach(function(m){
      (m.addedNodes||[]).forEach(function(node){
        if(!(node instanceof Element)) return;
        if(node.matches && node.matches(ROOT)) init(node);
        if(node.querySelectorAll) node.querySelectorAll(ROOT).forEach(init);
      });
    });
  });

  mo.observe(document.documentElement,{childList:true,subtree:true});

  /* ------------ Clicks: always add by data-add-item-id ------------- */
  var lastTouchTs = 0;

  function onAddClick(e){
    var btn = e.target && e.target.closest('.cross-sells__item-add[data-add-item-id]');
    if(!btn) return;

    var now = Date.now();
    if (e.type === 'click' && now - lastTouchTs < 350) return;

    if (typeof e.cancelable !== 'undefined' && e.cancelable) e.preventDefault();

    var id=btn.getAttribute('data-add-item-id');
    if(!id) return;

    btn.classList.add('is-loading');

    var holder=getDrawerEl();
    var prevKeys='';

    if(holder){
      var keys=[].map.call(holder.querySelectorAll('.quick-cart__item'), function(el){
        return el.getAttribute('data-key') || '';
      });
      prevKeys = keys.join(',');
    }

    postAddToCart(id,1)
      .then(function(){
        btn.classList.remove('is-loading');

        return refreshQuickCart()
          .then(function(){ return waitForDrawerItemsMutation(700); })
          .then(function(){ return waitForCartSettle(prevKeys, 1200); })
          .then(function(){ return refreshAllCrossSells(); });
      })
      .catch(function(){
        btn.classList.remove('is-loading');
      });
  }

  document.addEventListener('touchend', function(e){
    lastTouchTs = Date.now();
    onAddClick(e);
  }, {passive:false});

  document.addEventListener('click', onAddClick, {passive:false});

  /* ------------ Refresh triggers ------------- */
  var debouncedRefresh = debounce(function(){
    var holder=getDrawerEl();
    var prevKeys='';

    if(holder){
      var keys=[].map.call(holder.querySelectorAll('.quick-cart__item'), function(el){
        return el.getAttribute('data-key') || '';
      });
      prevKeys = keys.join(',');
    }

    refreshQuickCart()
      .then(function(){ return waitForDrawerItemsMutation(700); })
      .then(function(){ return waitForCartSettle(prevKeys, 1200); })
      .then(function(){ return refreshAllCrossSells(); });
  }, 250);

  document.addEventListener('click', function(e){
    if(e.target.closest('.quick-cart [data-remove-item], .quick-cart .quick-cart__item-remove')){
      debouncedRefresh();
      return;
    }

    if(e.target.closest('.quick-cart [data-add-quantity], .quick-cart [data-subtract-quantity]')){
      debouncedRefresh();
      return;
    }
  }, {passive:true});

  document.addEventListener('change', function(e){
    if(e.target.matches('.quick-cart [data-quantity-input], .quick-cart input[name="updates[]"]')){
      debouncedRefresh();
    }
  }, {passive:true});

  ['ajaxProduct:added','product:added','cart:change','cart:refresh','cart:updated','cart-drawer:open']
    .forEach(function(evt){
      document.addEventListener(evt, debouncedRefresh, {passive:true});
    });

})();